import React from "react";
import exclamation from "../../../assets/images/SVG/exclamation_danger.svg";
import errorInfo from "../../../assets/images/SVG/circle_close.svg";

const PaginaInformacion = ({ type, tittle, message }) => {

  const iconType = {
    exclamation: exclamation,
    errorInfo: errorInfo
  }

  return (
    <div id="centeredModal" className="modal-wrapper modal-is-open">
      <div className="overlay"></div>
      <div className="modal modal-centered">
        <div className="modal-content rounded-lg bg-white p-10 flex flex-col items-center justify-center w-2/3">
          <img src={iconType[type]} alt="Exclamation icon" className="w-1/3 " />
          <div className="text-primary text-opacity-700 text-3xl text-center mt-5 font-bold leading-none">
            {tittle}
          </div>
          <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
            {message}
          </p>
          <div className="w-2/3 mx-auto mt-5"></div>
        </div>
      </div>
    </div>
  );
};

export default PaginaInformacion;
